import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import StartUp from './views/StartUp.vue'
Vue.use(Router)

export default new Router({

    //mode:"history",
    scrollBehavior(to,from,saveTop){
        
            return {x:0,y:0}   
    },
    routes: [{
        path: '/',
        name: 'startup',
        //component: () => import('./views/StartUp.vue'),
        component:StartUp,
        meta:{isCheck:false},
    },{
        path: '/home',
        meta:{isCheck:false},
        name: 'home',
        component: Home,
    },
    {
        path: '/online',
        name: 'online',
        meta:{isCheck:false},
        component: () =>
            //import ( /* webpackChunkName: "about" */ './views/Online.vue')
            import ( /* webpackChunkName: "about" */ './views/OnlineOff.vue')
    },
    {
        path: '/policy',
        name: 'policy',
        meta:{isCheck:false},
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import ( /* webpackChunkName: "about" */ './views/policy/policy.vue')
    },
    {
        path: '/agreement',
        name: 'agreement',
        meta:{isCheck:false},
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import ( /* webpackChunkName: "about" */ './views/policy/agreement.vue')
    },
        {
            path: '/about',
            name: 'about',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () =>
                import ( /* webpackChunkName: "about" */ './views/About.vue')
        },
        {
            path: '/erporder',
            name: 'erporder',
            component: () => import ('./views/ErpOrderInfo.vue')
        },
        {
            path: '/cate',
            meta:{isCheck:false},
            name: 'category',
            component: () =>
                import ('./views/Category.vue')
        },
        {
            path: '/goodlist',
            meta:{isCheck:false},
            name: 'goodlist',
            component: () =>
                import ('./views/GoodList.vue'),
            // children:[
            //     {
            //         path: '/gooddetail/:goodsId',
            //         name: 'gooddetail',
            //         component: () =>
            //             import ('./views/GoodDetail.vue')
            //     },
            // ]
        },
        {
            path: '/gooddetail/:goodsId',
            name: 'gooddetail',
            meta:{isCheck:false},
            component: () =>
                import ('./views/GoodDetail.vue')
        },
        {
            path: '/order',
            name: 'order',
            component: () =>
                import ('./views/order/Order.vue')
        },
        {
            path: '/order/success',
            name: 'ordersuccess',
            component: () =>
                import ('./views/order/OrderSuccess.vue')
        },
        {
            path: '/bill/success',
            name: 'billsuccess',
            component: () =>
                import ('./views/order/BillSuccess.vue')
        },
        {
            path: '/order/pay',
            name: 'orderpay',
            component: () =>
                import ('./views/order/OrderPay.vue')
        },
        {
            path: '/order/billoffline',
            name: 'billoffline',
            component: () =>
                import ('./views/order/BillPayOffline.vue')
        },{
            path: '/order/billpay',
            name: 'billpay',
            component: () =>
                import ('./views/order/BillPay.vue')
        },
        {
            path: '/order/payoffline',
            name: 'orderpayoffline',
            component: () =>
                import ('./views/order/OrderPayOffline.vue')
        },
        {
            path: '/cart',
            name: 'cart',
            component: () =>
                import ('./views/Cart.vue')
        },
        {
            path: '/usercent',
            name: 'usercenter',
            component: () =>
                import ('./views/UserCenter.vue')
        },
        {
            path: '/user/usermobile',
            name: 'userMobile',
            component: () =>
                import ('./views/user/UserMobile.vue')
        },
        {
            path: '/login',
            meta:{isCheck:false},
            name: 'login',
            component: () =>
                import ('./views/Login.vue')
        },
        {
            path: '/register',
            meta:{isCheck:false},
            name: 'register',
            component: () =>
                import ('./views/Register.vue')
        },
        {
            path: '/binduser',
            name: 'binduser',
            meta:{isCheck:false},
            component: () =>
                import ('./views/BindUser.vue')
        },
        {
            path: '/xieyi',
            name: 'xieyi',
            component: () =>
                import ('./views/Xieyi.vue')
        },
        {
            path: '/info/infoId',
            name: 'info',
            component: () =>
                import ('./views/Info.vue')
        },
        {
            path: '/repass',
            meta:{isCheck:false},
            name: 'repass',
            component: () =>
                import ('./views/Repass.vue')
        },
        {
            path: '/user/address',
            name: 'useraddress',
            component: () =>
                import ('./views/user/UserAddress.vue')
        },
        {
            path: '/user/address/add',
            name: 'useraddressadd',
            component: () =>
                import ('./views/user/UserAddressAdd.vue')
        },
        {
            path: '/user/address/edit',
            name: 'useraddressedit',
            component: () =>
                import ('./views/user/UserAddressEdit.vue')
        },
        {
            path: '/user/info',
            name: 'userinfo',
            component: () =>
                import ('./views/user/UserInfo.vue')
        },
        {
            path: '/user/safe',
            name: 'usersafe',
            component: () =>
                import ('./views/user/UserSafe.vue')
        },
        {
            path: '/user/history',
            name: 'userhistory',
            component: () =>
                import ('./views/user/UserHistory.vue')
        },
        {
            path: '/user/collect',
            name: 'usercollect',
            component: () =>
                import ('./views/user/UserCollect.vue')
        },
        {
            path: '/user/comment',
            name: 'usercomment',
            component: () =>
                import ('./views/user/UserComment.vue')
        },
        {
            path: '/user/comment/add',
            name: 'usercommentadd',
            component: () =>
                import ('./views/user/UserCommentAdd.vue')
        },
        {
            path: '/user/message',
            name: 'usermessage',
            component: () =>
                import ('./views/user/UserMessage.vue')
        },
        {
            path: '/message/center',
            component: () =>
                import ('./views/user/MessageCenter.vue')
        },
        {
            path: '/chat',
            component: () =>
                import ('./views/user/Chat.vue')
        },
        {
            path: '/chat/list',
            component: () =>
                import ('./views/user/ChatList.vue')
        },
        {
            path: '/jgmessage',
            name: 'message',
            component: () =>
                import ('./views/user/Message.vue')
        },
        {
            path: '/message',
            name: 'usermessagecent',
            component: () =>
                import ('./views/user/UserMessageCenter.vue')
        },

        {
            path: '/user/cons',
            name: 'usercons',
            component: () =>
                import ('./views/user/UserCons.vue')
        },
        {
            path: '/user/order',
            name: 'userorder',
            component: () =>
                import ('./views/user/UserOrder.vue')

        },
        {
            path: '/user/order/detail',
            name: 'userorderdetail',
            component: () =>
                import ('./views/user/UserOrderDetail.vue')
        },
        {
            path: '/user/order/arrival',
            name: 'userorderarrival',
            component: () =>
                import ('./views/user/UserOrderArrival.vue')
        },
        {
            path: '/user/order/receive',
            name: 'userorderreceive',
            component: () =>
                import ('./views/user/UserOrderReceive.vue')
        },
        {
            path: '/user/order/cancel',
            name: 'userordercancel',
            component: () =>
                import ('./views/user/UserOrderCancel.vue')
        },
        {
            path: '/user/order/extend',
            name: 'userorderextend',
            component: () =>
                import ('./views/user/UserOrderExtend.vue')
        },
        {
            path: '/user/order/aftersale',
            name: 'userorderaftersale',
            component: () =>
                import ('./views/user/UserOrderAftersale.vue')
        },

        {
            path: '/user/integral',
            name: 'userintegral',
            component: () =>
                import ('./views/user/UserIntegral.vue')
        },
        {
            path: '/user/integral/detail',
            name: 'userintegraldetail',
            component: () =>
                import ('./views/user/UserIntegralDetail.vue')
        },
        {
            path: '/user/integral/order',
            name: 'userintegralorder',
            component: () =>
                import ('./views/user/UserIntegralOrder.vue')

        },
        {
            path: '/user/integral/order/receive',
            name: 'userintegralorderreceive',
            component: () =>
                import ('./views/user/UserIntegralOrderReceive.vue')
        },
        {
            path: '/user/integral/order/detail',
            name: 'userintegralorderdetail',
            component: () =>
                import ('./views/user/UserIntegralOrderDetail.vue')
        },
        {
            path: '/user/integral/order/approval',
            name: 'userintegralorderapproval',
            component: () =>
                import ('./views/user/UserIntegralOrderApproval.vue')
        },
        {
            path: '/user/bill',
            name: 'userbill',
            component: () =>
                import ('./views/user/UserBill.vue')
        },
        {
            path: '/user/bill/detail',
            name: 'userbilldetail',
            component: () =>
                import ('./views/user/UserBillDetail.vue')
        },
        {
            path: '/order/invoice/self',
            name: 'OrderInvoiceSelf',
            component: () =>
                import ('./views/order/OrderInvoiceSelf.vue')
        },
        {
            path: '/order/invoice/comp',
            name: 'OrderInvoiceComp',
            component: () =>
                import ('./views/order/OrderInvoiceComp.vue')
        },
        {
            path: '/staff/approval',
            name: 'approvalList',
            component: () =>
                import ('./views/staff/ApprovalList.vue')
        },
        {
            path: '/staff/approval/type',
            name: 'approvalType',
            component: () =>
                import ('./views/staff/ApprovalType.vue')
        },
        {
            path: '/staff/approval/milk',
            name: 'approvalMilk',
            component: () =>
                import ('./views/staff/ApprovalMilk.vue')
        },
        {
            path: '/staff/approval/milkRepaymentDetail',
            name: 'approvalMilkRepaymentDetail',
            component: () =>
                import ('./views/staff/ApprovalMilkRepaymentDetail.vue')
        },
        {
            path: '/staff/approval/detail',
            name: 'approvalDetail',
            component: () =>
                import ('./views/staff/ApprovalDetail.vue')
        },
        {
            path: '/staff/approval/offlinePay',
            name: 'approvalOfflinePay',
            component: () =>
                import ('./views/staff/ApprovalOfflinePay.vue')
        },{
            path: '/staff/integral/order',
            name: 'staffIntegralOrder',
            component: () =>
                import ('./views/staff/IntegralOrder.vue')
        },{
            path: '/order/out-order',
            name: 'out-order',
            component: () =>
                import ('./views/order/OutOrder.vue')
        },{
            path: '/game/luck',
            name: 'luck',
            component: () =>
                import ('./views/game/luckywheel.vue')
        }, {
            path: '/game/luckyDraw',
            name: 'luck',
            component: () =>
                import ('./views/game/luckyDraw.vue')
        }, {
            path: '/game/egg',
            name: 'eggs',
            component: () =>
                import ('./views/game/smashegg.vue')
        },{
            path: '/order/staff/order/detail',
            name: 'staff-order-detail',
            component: () =>
                import ('./views/order/orderDetail.vue')
        },{
            path: '/stock/stocklist',
            name: 'stock-stocklist',
            component: () =>
                import ('./views/stock/StockList.vue')
        },
        {
            path: '/stock/stocklistc',
            name: 'stock-stocklistc',
            component: () =>
                import ('./views/stock/StockListC.vue')
        },
        {
            path:'/integral/home',
            name:'integralhome',
            component:()=> import('./views/integral/Home.vue')
        },
        {
            path:'/integral/goodlist',
            name:'integralgoodlist',
            component:()=> import('./views/integral/GoodList.vue')

        },
        {
            path:'/integral/gooddetail/:goodsId',
            name:'integralgooddetail',
            component:()=> import('./views/integral/GoodDetail.vue')
        },
        {
            path:'/integral/order',
            name:'integralorder',
            component:()=> import('./views/integral/Order.vue')
        },
        {
            path:'/integral/order/success',
            name:'integralordersuccess',
            component:()=> import('./views/integral/OrderSuccess.vue')
        },
        {
            path:'/user/order/deliver-goods-num',
            name:'deliver-goods-num',
            component:()=> import('./views/user/DeliverGoodsNum.vue')
        },
        {
            path:'/staff/delivery/list',
            name:'deliveryList',
            component:()=> import('./views/staff/DeliveryList.vue')
        },
        {
            path:'/staff/delivery/detail',
            name:'deliveryDetail',
            component:()=> import('./views/staff/DeliveryDetail.vue')
        },
        {
            path:'/staff/delivery/refunddetail',
            name:'refunddetail',
            component:()=> import('./views/staff/RefundDeliveryDetail.vue')
        }
        ,
        {
            path:'/user/order/depositGood',
            name:'depositGood',
            component:()=> import('./views/user/DepositGood.vue')
        }
        ,
        {
            path:'/user/order/userIntegralRule',
            name:'userIntegralRule',
            component:()=> import('./views/user/UserIntegralRule.vue')
        }
        ,
        {
            path:'/user/order/userIntegralGet',
            name:'userIntegralGet',
            component:()=> import('./views/user/UserIntegralGet.vue')
        }
        ,
        {
            path:'/user/qrCode',
            name:'qrCode',
            component:()=> import('./views/user/QrCode.vue')
        }
        ,
        {
            path:'/goodEvaluation',
            name:'goodEvaluation',
            component:()=> import('./views/GoodEvaluation.vue')
        }
        ,
        {
            path:'/goodInquiry',
            name:'goodInquiry',
            component:()=> import('./views/GoodInquiry.vue')
        },
        {
            path: '/user/replaceOrder',
            name: 'replaceOrder',
            component: () =>
                import ('./views/user/UserReplaceOrder.vue')
        },
        {
            path: '/user/records',
            name: 'Records',
            component: () =>
                import ('./views/user/UserRecords.vue')
        },
        {
            path: '/user/order/outreceive',
            name: 'outreceive',
            component: () =>
                import ('./views/user/UserOrderOutReceive.vue')
        },
        {
            path: '/staff/order/delivery/plan',
            name: 'deliveryplan',
            component: () =>
                import ('./views/staff/DeliveryGoodPlan.vue')
        },
        {
            path: '/approval/delivery/plan',//创建，查看，有编辑按钮 分批计划
            name: 'appdeliveryplan',
            component: () =>
                import ('./views/approval/DeliveryPlan.vue')
        },

        {
            path: '/user/bindAccount',
            name: 'bindAccount',
            component: () =>
                import ('./views/user/BindAccount.vue')
        },
        {
            path: '/staff/order/delivery/plan/show',
            name: 'deliveryplan',
            component: () =>
                import ('./views/staff/DeliveryGoodPlanShow.vue')
        }
        ,
        {
            path: '/staff/order/delivery/plan/update',
            name: 'deliveryplan',
            component: () =>
                import ('./views/staff/DeliveryGoodPlanUpdate.vue')
        },
        {
            path: '/user/order/intergral',
            name: 'userOrderIntergral',
            component: () =>
                import ('./views/user/OrderIntergral.vue')
        },
        {
            path: '/user/order/intergral2',
            name: 'userOrderIntergral',
            component: () =>
                import ('./views/user/OrderIntergral2.vue')
        },
        {
            path: '/user/task',
            name: 'userTask',
            component: () =>
                import ('./views/user/UserTask.vue')
        },
        {
            path: '/approval',
            name: 'approval',
            component: () =>
                import ('./views/approval/Approval.vue')
        },
        {
            path: '/edit/approval',
            name: 'editApproval',
            component: () =>
                import ('./views/approval/EditApproval.vue')
        }
    ]
})